import { render, staticRenderFns } from "./setProductUnit.vue?vue&type=template&id=475aaa5c&scoped=true"
import script from "./setProductUnit.vue?vue&type=script&lang=js"
export * from "./setProductUnit.vue?vue&type=script&lang=js"
import style0 from "./setProductUnit.vue?vue&type=style&index=0&id=475aaa5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475aaa5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('475aaa5c')) {
      api.createRecord('475aaa5c', component.options)
    } else {
      api.reload('475aaa5c', component.options)
    }
    module.hot.accept("./setProductUnit.vue?vue&type=template&id=475aaa5c&scoped=true", function () {
      api.rerender('475aaa5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/components/setProductUnit.vue"
export default component.exports